import { render, staticRenderFns } from "./ProjectViewPMGrid.vue?vue&type=template&id=010f30ea&"
import script from "./ProjectViewPMGrid.vue?vue&type=script&lang=ts&"
export * from "./ProjectViewPMGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectViewPMGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports